
// import React, { useState,useEffect } from 'react'; // Ensure useState is imported
// import { useNavigate } from 'react-router-dom';
// import styled from 'styled-components';
// import { FaLock, FaUser, FaEye, FaEyeSlash } from 'react-icons/fa';
// import { Link } from 'react-router-dom';
// import axios from 'axios'

// const LoginPage = () => {
//   const navigate = useNavigate();
//   const [error, setError] = useState('');
 
//   const [email, setEmail] = useState('');
//   const [password, setPassword] = useState('');
//   const [isFormValid, setIsFormValid] = useState(false);
//   const [showForgotPassword, setShowForgotPassword] = useState(false);
//   const [newPassword, setNewPassword] = useState('');
//   const [resetMessage, setResetMessage] = useState('');
//   const [isResetFormValid, setIsResetFormValid] = useState(false);
//   const [showPassword, setShowPassword] = useState(false);
//   const [showNewPassword, setShowNewPassword] = useState(false);
//   const [username, setUsername] = useState('');
//   const [userNo, setUserNo] = useState('');
//   const [loginForm, setLoginForm] = useState({ logs: null });

//   // Get IP/device info for login logs (optional - does not block login)
//   useEffect(() => {
//     const ipUrl = process.env.REACT_APP_IP_API_URL || 'https://ipapi.co/json';
//     axios.get(ipUrl)
//       .then((res) => {
//         setLoginForm(prev => ({ ...prev, logs: res.data }));
//       })
//       .catch((err) => {
//         if (err.response?.status === 429) {
//           console.log('IP API rate limited (429) - continuing with login');
//         } else {
//           console.log('IP API failed:', err.message, '- continuing with login');
//         }
//         setLoginForm(prev => ({ ...prev, logs: '' }));
//       });
//   }, []);

//   useEffect(() => {
//     const storedUsername = localStorage.getItem('UserNo'); // Retrieve from LocalStorage
//     if (storedUsername) {
//       setUsername(storedUsername);
//     }
//   }, []);
//   console.log("USErnameNo",username)

//   useEffect(() => {
//     const fetchUserNo = async () => {
//       try {
//         const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/userLoginUserNo/${username}`);
//         const data = await response.json();

//         if (data.success) {
//           setUserNo(data.userNo);
//         } else {
//           console.error('User not found');
//         }
//       } catch (error) {
//         console.error('Error fetching userNo:', error);
//       }
//     };

//     if (username) {
//       fetchUserNo();
//     }
//   }, [username]);
  
//   const validateForm = () => {
//     const isEmailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
//     const isPasswordValid = password.length >= 6;
//     setIsFormValid(isEmailValid && isPasswordValid);
//   };

//   const validateResetForm = () => {
//     const isEmailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
//     const isNewPasswordValid = newPassword.length >= 6;
//     setIsResetFormValid(isEmailValid && isNewPasswordValid);
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       const response = await axios.post(
//         `${process.env.REACT_APP_BASE_URL}/api/login`,
//         { userNo, password, logs: loginForm.logs }
//       );

//       if (response.status === 200) {
//         if (response.data.token) {
//           localStorage.setItem('token', response.data.token);
//           axios.defaults.headers.common['Authorization'] = `Bearer ${response.data.token}`;
//         }
//         localStorage.setItem('user', JSON.stringify(response.data.user));
//         localStorage.setItem('wallet', JSON.stringify(response.data.wallet || {}));
//         localStorage.setItem('history', JSON.stringify(response.data.history || []));

//         if (response.data.isFirstLogin) {
//           navigate('/change-password');
//         } else {
//           navigate('/');
//           window.location.reload();
//         }
//       } else {
//         setError(response.data?.message || 'Login failed. Please try again.');
//       }
//     } catch (error) {
//       setError(error.response?.data?.message || 'Login failed. Please try again.');
//       console.log(error);
//     }
//   };

//   const handleForgotPassword = async (e) => {
//     e.preventDefault();
//     try {
//       const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/forgot-password`, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ email, newPassword }),
//       });

//       const data = await response.json();
//       if (response.ok) {
//         setResetMessage('Password reset successful! You can now log in with the new password.');
//         setShowForgotPassword(false);
//         setNewPassword('');
//       } else {
//         setResetMessage(data.message || 'Password reset failed. Try again.');
//       }
//     } catch (error) {
//       setResetMessage('Error connecting to server. Try again later.');
//     }
//   };

//   return (
//     <LoginPageContainer>
//       <LoginFormWrapper>
//         <LoginFormContainer>
//           <Logo>
//             <BrandHeading>
//               <BrandMain>9X</BrandMain>
//               <BrandAccent>BET</BrandAccent>
//             </BrandHeading>
//           </Logo>

//           {!showForgotPassword ? (
//             <>
//               <FormTitle>Sign in</FormTitle>
//               {error && <ErrorMessage>{error}</ErrorMessage>}
//               <form onSubmit={handleSubmit}>
//                 <FormGroup>
//                   <InputGroup>
//                     <IconWrapper>
//                       C
//                     </IconWrapper>
//                     <Input
//                       type="text"
//                       placeholder="Client Code*"
//                       value={userNo}
//                       onChange={(e) => setUserNo(e.target.value)}
//                       required
//                     />
//                   </InputGroup>
//                 </FormGroup>

//                 <FormGroup>
//                   <InputGroup>
//                     <IconWrapper>
//                       <FaLock />
//                     </IconWrapper>
//                     <Input
//                       type={showPassword ? "text" : "password"}
//                       placeholder="Password*"
//                       value={password}
//                       onChange={(e) => {
//                         setPassword(e.target.value);
//                       }}
//                       required
//                     />
//                     <PasswordToggle onClick={() => setShowPassword(!showPassword)}>
//                       {showPassword ? <FaEyeSlash /> : <FaEye />}
//                     </PasswordToggle>
//                   </InputGroup>
//                 </FormGroup>

//                 <RememberRow>
//                   <RememberCheckbox type="checkbox" id="rememberMe" />
//                   <RememberLabel htmlFor="rememberMe">Remember me</RememberLabel>
//                 </RememberRow>

//                 <Button type="submit">
//                   SIGN IN
//                 </Button>
//               </form>
//             </>
//           ) : (
//             <>
//               <FormTitle>Reset Password</FormTitle>
//               {resetMessage && <SuccessMessage>{resetMessage}</SuccessMessage>}
//               <form onSubmit={handleForgotPassword}>
//                 <FormGroup>
//                   <InputGroup>
//                     <IconWrapper>
//                       <FaUser />
//                     </IconWrapper>
//                     <Input
//                       type="email"
//                       placeholder="Your Email"
//                       value={email}
//                       onChange={(e) => {
//                         setEmail(e.target.value);
//                         validateResetForm();
//                       }}
//                       required
//                     />
//                   </InputGroup>
//                 </FormGroup>

//                 <FormGroup>
//                   <InputGroup>
//                     <IconWrapper>
//                       <FaLock />
//                     </IconWrapper>
//                     <Input
//                       type={showNewPassword ? "text" : "password"}
//                       placeholder="New Password"
//                       value={newPassword}
//                       onChange={(e) => {
//                         setNewPassword(e.target.value);
//                         validateResetForm();
//                       }}
//                       required
//                     />
//                     <PasswordToggle onClick={() => setShowNewPassword(!showNewPassword)}>
//                       {showNewPassword ? <FaEyeSlash /> : <FaEye />}
//                     </PasswordToggle>
//                   </InputGroup>
//                 </FormGroup>

//                 <Button type="submit" disabled={!isResetFormValid}>Reset Password</Button>
//                 <BackToLoginLink onClick={() => setShowForgotPassword(false)}>
//                   Back to Login
//                 </BackToLoginLink>
//               </form>
//             </>
//           )}
//         </LoginFormContainer>

//         <FooterText>Copyright ©YOX9.com 2023.</FooterText>
//       </LoginFormWrapper>
//     </LoginPageContainer>
//   );
// };


// // Styled Components
// const LoginPageContainer = styled.div`
//   display: flex;
//   min-height: 100vh;
//   background: #ffffff;
//   justify-content: center;
//   align-items: flex-start;
//   padding-top: 4rem;
// `;

// const LoginFormWrapper = styled.div`
//   width: 100%;
//   max-width: 400px;
//   display: flex;
//   flex-direction: column;
//   align-items: center;
// `;

// const LoginFormContainer = styled.div`
//   width: 100%;
//   max-width: 400px;
//   padding: 2rem 1.5rem 1.5rem;
//   text-align: center;
// `;

// const Logo = styled.div`
//   margin-bottom: 2rem;
// `;

// const BrandHeading = styled.h1`
//   font-size: 6.2rem;
//   font-weight: 700;
//   margin-bottom: -1.5rem;
// `;

// const BrandMain = styled.span`
//   color:#e91e63;
//   margin-right: 0.2rem;
// `;

// const BrandAccent = styled.span`
//   color:#e91e63;
// `;

// const FormTitle = styled.h2`
//   color: #1b5fc5;
//   margin-bottom: 2rem;
//   font-weight: 600;
//   font-size: 1.2rem;
// `;

// const ErrorMessage = styled.p`
//   color: #dc2626;
//   text-align: center;
//   margin-bottom: 1rem;
//   font-size: 0.9rem;
// `;

// const FormGroup = styled.div`
//   margin-bottom: 1rem;
// `;

// const InputGroup = styled.div`
//   display: flex;
//   align-items: center;
//   border: 1px solid #d0d0d0;
//   background: white;
//   position: relative;
//   min-height: 48px;
// `;

// const IconWrapper = styled.div`
//   width: 40px;
//   height: 100%;
//   background: #ffffff;
//   color: #757575;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   font-weight: 500;
//   font-size: 14px;
//   border-right: 1px solid #e0e0e0;
// `;

// const Input = styled.input`
//   flex: 1;
//   padding: 12px 15px;
//   border: none;
//   background: transparent;
//   outline: none;
//   font-size: 14px;
//   color: #333;

//   &::placeholder {
//     color: #999;
//   }
// `;

// const Button = styled.button`
//   width: 100%;
//   padding: 12px;
//   background: #e91e63;
//   color: white;
//   border: none;
//   cursor: pointer;
//   font-size: 14px;
//   margin-top: 1rem;
//   margin-bottom: 1.5rem;
//   text-transform: uppercase;
//   font-weight: 600;

//   &:hover:not(:disabled) {
//     background: #d8004b;
//   }

//   &:disabled {
//     opacity: 0.6;
//     cursor: not-allowed;
//   }
// `;

// const ForgotPasswordLink = styled.p`
//   text-align: right;
//   cursor: pointer;
//   color: #666;
//   font-size: 12px;
//   margin: 0.5rem 0;
// `;

// const BackToLoginLink = styled.p`
//   text-align: center;
//   cursor: pointer;
//   color: #666;
//   margin-top: 1rem;
//   font-size: 12px;
// `;

// const SuccessMessage = styled.p`
//   color: #22c55e;
//   text-align: center;
//   margin-bottom: 1rem;
// `;

// const PasswordToggle = styled.div`
//   position: absolute;
//   right: 15px;
//   color: #666;
//   cursor: pointer;
//   display: flex;
//   align-items: center;
//   justify-content: center;

//   &:hover {
//     color: #333;
//   }
// `;

// const RememberRow = styled.div`
//   display: flex;
//   align-items: center;
//   justify-content: flex-start;
//   gap: 8px;
//   margin-top: 0.25rem;
// `;

// const RememberCheckbox = styled.input`
//   width: 14px;
//   height: 14px;
//   cursor: pointer;
// `;

// const RememberLabel = styled.label`
//   font-size: 12px;
//   color: #333;
//   cursor: pointer;
// `;

// const FooterText = styled.p`
//   margin-top: 3rem;
//   font-size: 12px;
//   color: #9e9e9e;
//   text-align: center;
// `;

// export default LoginPage;



// import React, { useState,useEffect } from 'react'; // Ensure useState is imported
// import { useNavigate } from 'react-router-dom';
// import styled from 'styled-components';
// import { FaLock, FaUser, FaEye, FaEyeSlash, FaChevronLeft, FaChevronRight } from 'react-icons/fa';
// import { Link } from 'react-router-dom';
// import axios from 'axios';
// import logoImage from '../assets/frontimges/proff.png';

// const LoginPage = () => {
//   const navigate = useNavigate();
//   const [error, setError] = useState('');
 
//   const [email, setEmail] = useState('');
//   const [password, setPassword] = useState('');
//   const [isFormValid, setIsFormValid] = useState(false);
//   const [showForgotPassword, setShowForgotPassword] = useState(false);
//   const [newPassword, setNewPassword] = useState('');
//   const [resetMessage, setResetMessage] = useState('');
//   const [isResetFormValid, setIsResetFormValid] = useState(false);
//   const [showPassword, setShowPassword] = useState(false);
//   const [showNewPassword, setShowNewPassword] = useState(false);
//   const [username, setUsername] = useState('');
//   const [userNo, setUserNo] = useState('');
//   const [loginForm, setLoginForm] = useState({ logs: null });

//   // Get IP/device info for login logs (optional - does not block login)
//   useEffect(() => {
//     const ipUrl = process.env.REACT_APP_IP_API_URL || 'https://ipapi.co/json';
//     axios.get(ipUrl)
//       .then((res) => {
//         setLoginForm(prev => ({ ...prev, logs: res.data }));
//       })
//       .catch((err) => {
//         if (err.response?.status === 429) {
//           console.log('IP API rate limited (429) - continuing with login');
//         } else {
//           console.log('IP API failed:', err.message, '- continuing with login');
//         }
//         setLoginForm(prev => ({ ...prev, logs: '' }));
//       });
//   }, []);

//   useEffect(() => {
//     const storedUsername = localStorage.getItem('UserNo'); // Retrieve from LocalStorage
//     if (storedUsername) {
//       setUsername(storedUsername);
//     }
//   }, []);
//   console.log("USErnameNo",username)

//   useEffect(() => {
//     const fetchUserNo = async () => {
//       try {
//         const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/userLoginUserNo/${username}`);
//         const data = await response.json();

//         if (data.success) {
//           setUserNo(data.userNo);
//         } else {
//           console.error('User not found');
//         }
//       } catch (error) {
//         console.error('Error fetching userNo:', error);
//       }
//     };

//     if (username) {
//       fetchUserNo();
//     }
//   }, [username]);
  
//   const validateForm = () => {
//     const isEmailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
//     const isPasswordValid = password.length >= 6;
//     setIsFormValid(isEmailValid && isPasswordValid);
//   };

//   const validateResetForm = () => {
//     const isEmailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
//     const isNewPasswordValid = newPassword.length >= 6;
//     setIsResetFormValid(isEmailValid && isNewPasswordValid);
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       const response = await axios.post(
//         `${process.env.REACT_APP_BASE_URL}/api/login`,
//         { userNo, password, logs: loginForm.logs }
//       );

//       if (response.status === 200) {
//         if (response.data.token) {
//           localStorage.setItem('token', response.data.token);
//           axios.defaults.headers.common['Authorization'] = `Bearer ${response.data.token}`;
//         }
//         localStorage.setItem('user', JSON.stringify(response.data.user));
//         localStorage.setItem('wallet', JSON.stringify(response.data.wallet || {}));
//         localStorage.setItem('history', JSON.stringify(response.data.history || []));

//         if (response.data.isFirstLogin) {
//           navigate('/change-password');
//         } else {
//           navigate('/');
//           window.location.reload();
//         }
//       } else {
//         setError(response.data?.message || 'Login failed. Please try again.');
//       }
//     } catch (error) {
//       setError(error.response?.data?.message || 'Login failed. Please try again.');
//       console.log(error);
//     }
//   };

//   const handleForgotPassword = async (e) => {
//     e.preventDefault();
//     try {
//       const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/forgot-password`, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ email, newPassword }),
//       });

//       const data = await response.json();
//       if (response.ok) {
//         setResetMessage('Password reset successful! You can now log in with the new password.');
//         setShowForgotPassword(false);
//         setNewPassword('');
//       } else {
//         setResetMessage(data.message || 'Password reset failed. Try again.');
//       }
//     } catch (error) {
//       setResetMessage('Error connecting to server. Try again later.');
//     }
//   };

//   return (
//     <LoginPageContainer>
//       <LoginFormWrapper>
//         <ClassicToggle>
//           <ToggleButton><FaChevronLeft /></ToggleButton>
//           <ToggleText>CLASSIC</ToggleText>
//           <ToggleButton><FaChevronRight /></ToggleButton>
//         </ClassicToggle>
        
//         <LoginFormContainer>
//           <Logo>
//             <LogoImage src={logoImage} alt="BetGuru Logo" />
//           </Logo>

//           {!showForgotPassword ? (
//             <>
//               {error && <ErrorMessage>{error}</ErrorMessage>}
//               <form onSubmit={handleSubmit}>
//                 <FormGroup>
//                   <InputLabel>Code</InputLabel>
//                   <InputGroup>
//                     <IconWrapper>
//                       C
//                     </IconWrapper>
//                     <Input
//                       type="text"
//                       placeholder="Code"
//                       value={userNo}
//                       onChange={(e) => setUserNo(e.target.value)}
//                       required
//                     />
//                   </InputGroup>
//                 </FormGroup>

//                 <FormGroup>
//                   <InputLabel>Password</InputLabel>
//                   <InputGroup>
//                     <IconWrapper>
//                       <FaLock />
//                     </IconWrapper>
//                     <Input
//                       type={showPassword ? "text" : "password"}
//                       placeholder="Password"
//                       value={password}
//                       onChange={(e) => {
//                         setPassword(e.target.value);
//                       }}
//                       required
//                     />
//                     <PasswordToggle onClick={() => setShowPassword(!showPassword)}>
//                       {showPassword ? <FaEyeSlash /> : <FaEye />}
//                     </PasswordToggle>
//                   </InputGroup>
//                 </FormGroup>

//                 <RememberRow>
//                   <RememberCheckbox type="checkbox" id="rememberMe" />
//                   <RememberLabel htmlFor="rememberMe">Remember me</RememberLabel>
//                 </RememberRow>

//                 <LoginButton type="submit">
//                   Log in
//                 </LoginButton>
                
//                 <DemoButton type="button">
//                   Demo
//                 </DemoButton>
//               </form>
//             </>
//           ) : (
//             <>
//               {resetMessage && <SuccessMessage>{resetMessage}</SuccessMessage>}
//               <form onSubmit={handleForgotPassword}>
//                 <FormGroup>
//                   <InputLabel>Email</InputLabel>
//                   <InputGroup>
//                     <IconWrapper>
//                       <FaUser />
//                     </IconWrapper>
//                     <Input
//                       type="email"
//                       placeholder="Your Email"
//                       value={email}
//                       onChange={(e) => {
//                         setEmail(e.target.value);
//                         validateResetForm();
//                       }}
//                       required
//                     />
//                   </InputGroup>
//                 </FormGroup>

//                 <FormGroup>
//                   <InputLabel>New Password</InputLabel>
//                   <InputGroup>
//                     <IconWrapper>
//                       <FaLock />
//                     </IconWrapper>
//                     <Input
//                       type={showNewPassword ? "text" : "password"}
//                       placeholder="New Password"
//                       value={newPassword}
//                       onChange={(e) => {
//                         setNewPassword(e.target.value);
//                         validateResetForm();
//                       }}
//                       required
//                     />
//                     <PasswordToggle onClick={() => setShowNewPassword(!showNewPassword)}>
//                       {showNewPassword ? <FaEyeSlash /> : <FaEye />}
//                     </PasswordToggle>
//                   </InputGroup>
//                 </FormGroup>

//                 <LoginButton type="submit" disabled={!isResetFormValid}>Reset Password</LoginButton>
//                 <BackToLoginLink onClick={() => setShowForgotPassword(false)}>
//                   Back to Login
//                 </BackToLoginLink>
//               </form>
//             </>
//           )}
//         </LoginFormContainer>

//         <FooterText>© 2023 9xBet24</FooterText>
//       </LoginFormWrapper>
//     </LoginPageContainer>
//   );
// };


// // Styled Components
// const LoginPageContainer = styled.div`
//   display: flex;
//   min-height: 100vh;
//   background: linear-gradient(180deg, #6B46C1 0%, #3B82F6 100%);
//   justify-content: center;
//   align-items: center;
//   padding: 2rem .5rem;
//   position: relative;
// `;

// const LoginFormWrapper = styled.div`
//   width: 100%;
//   max-width: 420px;
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   position: relative;
// `;

// const ClassicToggle = styled.div`
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   gap: 8px;
//   background: rgba(0, 0, 0, 0.3);
//   border-radius: 25px;
//   padding: 6px 12px;
//   margin-bottom: 1rem;
//   position: absolute;
//   top: -50px;
//   z-index: 10;
// `;

// const ToggleButton = styled.button`
//   background: rgba(255, 255, 255, 0.2);
//   border: none;
//   border-radius: 50%;
//   width: 28px;
//   height: 28px;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   color: white;
//   cursor: pointer;
//   font-size: 12px;
  
//   &:hover {
//     background: rgba(255, 255, 255, 0.3);
//   }
// `;

// const ToggleText = styled.span`
//   color: white;
//   font-weight: 600;
//   font-size: 12px;
//   letter-spacing: 1px;
//   text-transform: uppercase;
// `;

// const LoginFormContainer = styled.div`
//   width: 100%;
//   max-width: 420px;
//   padding: 2.5rem 2rem;
//   text-align: center;
//   background: rgba(75, 50, 120, 0.5);
//   backdrop-filter: blur(10px);
//   border: 1px solid rgba(255, 255, 255, 0.1);
//   border-radius: 20px;
//   box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
// `;

// const Logo = styled.div`
//   margin-bottom: 2rem;
//   display: flex;
//   justify-content: center;
//   align-items: center;
// `;

// const LogoImage = styled.img`
//   width: 120px;
//   height: 120px;
//   object-fit: contain;
//   border-radius: 50%;
// `;

// const ErrorMessage = styled.p`
//   color: #ff6b6b;
//   text-align: center;
//   margin-bottom: 1rem;
//   font-size: 0.9rem;
//   background: rgba(255, 107, 107, 0.1);
//   padding: 8px;
//   border-radius: 8px;
// `;

// const FormGroup = styled.div`
//   margin-bottom: 1.25rem;
//   text-align: left;
// `;

// const InputLabel = styled.label`
//   display: block;
//   color: rgba(255, 255, 255, 0.7);
//   font-size: 0.85rem;
//   margin-bottom: 0.5rem;
//   font-weight: 500;
// `;

// const InputGroup = styled.div`
//   display: flex;
//   align-items: center;
//   border: 1px solid rgba(255, 255, 255, 0.2);
//   background: rgba(255, 255, 255, 0.1);
//   border-radius: 12px;
//   position: relative;
//   min-height: 50px;
//   overflow: hidden;
// `;

// const IconWrapper = styled.div`
//   width: 50px;
//   height: 100%;

//   color: rgba(255, 255, 255, 0.9);
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   font-weight: 600;
//   font-size: 16px;
//   border-right: 1px solid rgba(255, 255, 255, 0.2);
//   flex-shrink: 0;
// `;

// const Input = styled.input`
//   flex: 1;
//   padding: 14px 16px;
//   border: none;
//   background: transparent;
//   outline: none;
//   font-size: 14px;
//   color: white;

//   &::placeholder {
//     color: rgba(255, 255, 255, 0.5);
//   }
// `;

// const BackToLoginLink = styled.p`
//   text-align: center;
//   cursor: pointer;
//   color: rgba(255, 255, 255, 0.7);
//   margin-top: 1rem;
//   font-size: 12px;
  
//   &:hover {
//     color: white;
//   }
// `;

// const SuccessMessage = styled.p`
//   color: #4ade80;
//   text-align: center;
//   margin-bottom: 1rem;
//   background: rgba(74, 222, 128, 0.1);
//   padding: 8px;
//   border-radius: 8px;
// `;

// const PasswordToggle = styled.div`
//   position: absolute;
//   right: 15px;
//   color: rgba(255, 255, 255, 0.7);
//   cursor: pointer;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   padding: 8px;

//   &:hover {
//     color: white;
//   }
// `;

// const RememberRow = styled.div`
//   display: flex;
//   align-items: center;
//   justify-content: flex-start;
//   gap: 10px;
//   margin-top: 0.5rem;
//   margin-bottom: 1rem;
// `;

// const RememberCheckbox = styled.input`
//   width: 18px;
//   height: 18px;
//   cursor: pointer;
//   accent-color: rgba(255, 255, 255, 0.8);
// `;

// const RememberLabel = styled.label`
//   font-size: 14px;
//   color: rgba(255, 255, 255, 0.9);
//   cursor: pointer;
//   user-select: none;
// `;

// const LoginButton = styled.button`
//   width: 100%;
//   padding: 14px;
//   background: #8B7355;
//   color: white;
//   border: none;
//   cursor: pointer;
//   font-size: 15px;
//   margin-bottom: 1rem;
//   font-weight: 600;
//   border-radius: 12px;
//   box-shadow: 0 4px 12px rgba(139, 115, 85, 0.4);
//   transition: all 0.3s ease;

//   &:hover:not(:disabled) {
//     background: #7a6348;
//     box-shadow: 0 6px 16px rgba(139, 115, 85, 0.5);
//     transform: translateY(-2px);
//   }

//   &:disabled {
//     opacity: 0.6;
//     cursor: not-allowed;
//   }
// `;

// const DemoButton = styled.button`
//   width: 100%;
//   padding: 14px;
//   background: #3B82F6;
//   color: white;
//   border: none;
//   cursor: pointer;
//   font-size: 15px;
//   font-weight: 600;
//   border-radius: 12px;
//   box-shadow: 0 4px 12px rgba(59, 130, 246, 0.4);
//   transition: all 0.3s ease;

//   &:hover {
//     background: #2563EB;
//     box-shadow: 0 6px 16px rgba(59, 130, 246, 0.5);
//     transform: translateY(-2px);
//   }
// `;

// const FooterText = styled.p`
//   margin-top: 2rem;
//   font-size: 12px;
//   color: rgba(255, 255, 255, 0.6);
//   text-align: center;
// `;

// export default LoginPage;


import React, { useState,useEffect } from 'react'; // Ensure useState is imported
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { FaLock, FaUser, FaEye, FaEyeSlash, FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import axios from 'axios';
import logoImage from '../assets/frontimges/logo.png';

const LoginPage = () => {
  const navigate = useNavigate();
  const [error, setError] = useState('');
 
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isFormValid, setIsFormValid] = useState(false);
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const [newPassword, setNewPassword] = useState('');
  const [resetMessage, setResetMessage] = useState('');
  const [isResetFormValid, setIsResetFormValid] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [username, setUsername] = useState('');
  const [userNo, setUserNo] = useState('');
  const [loginForm, setLoginForm] = useState({ logs: null });

  // Get IP/device info for login logs (optional - does not block login)
  useEffect(() => {
    const ipUrl = process.env.REACT_APP_IP_API_URL || 'https://ipapi.co/json';
    axios.get(ipUrl)
      .then((res) => {
        setLoginForm(prev => ({ ...prev, logs: res.data }));
      })
      .catch((err) => {
        if (err.response?.status === 429) {
          console.log('IP API rate limited (429) - continuing with login');
        } else {
          console.log('IP API failed:', err.message, '- continuing with login');
        }
        setLoginForm(prev => ({ ...prev, logs: '' }));
      });
  }, []);

  useEffect(() => {
    const storedUsername = localStorage.getItem('UserNo'); // Retrieve from LocalStorage
    if (storedUsername) {
      setUsername(storedUsername);
    }
  }, []);
  console.log("USErnameNo",username)

  useEffect(() => {
    const fetchUserNo = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/userLoginUserNo/${username}`);
        const data = await response.json();

        if (data.success) {
          // Remove 'C' prefix if present, store only the number part
          const userNoValue = data.userNo ? data.userNo.replace(/^C/i, '') : '';
          setUserNo(userNoValue);
        } else {
          console.error('User not found');
        }
      } catch (error) {
        console.error('Error fetching userNo:', error);
      }
    };

    if (username) {
      fetchUserNo();
    }
  }, [username]);
  
  const validateForm = () => {
    const isEmailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    const isPasswordValid = password.length >= 6;
    setIsFormValid(isEmailValid && isPasswordValid);
  };

  const validateResetForm = () => {
    const isEmailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    const isNewPasswordValid = newPassword.length >= 6;
    setIsResetFormValid(isEmailValid && isNewPasswordValid);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // Remove 'C' prefix if user typed it, then prepend 'C' for API
      const userNoValue = userNo.replace(/^C/i, ''); // Remove C if present
      const userNoWithPrefix = `C${userNoValue}`; // Always prepend C
      
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/login`,
        { userNo: userNoWithPrefix, password, logs: loginForm.logs }
      );

      if (response.status === 200) {
        if (response.data.token) {
          localStorage.setItem('token', response.data.token);
          axios.defaults.headers.common['Authorization'] = `Bearer ${response.data.token}`;
        }
        localStorage.setItem('user', JSON.stringify(response.data.user));
        localStorage.setItem('wallet', JSON.stringify(response.data.wallet || {}));
        localStorage.setItem('history', JSON.stringify(response.data.history || []));

        if (response.data.isFirstLogin) {
          navigate('/change-password');
        } else {
          navigate('/');
          window.location.reload();
        }
      } else {
        setError(response.data?.message || 'Login failed. Please try again.');
      }
    } catch (error) {
      setError(error.response?.data?.message || 'Login failed. Please try again.');
      console.log(error);
    }
  };

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, newPassword }),
      });

      const data = await response.json();
      if (response.ok) {
        setResetMessage('Password reset successful! You can now log in with the new password.');
        setShowForgotPassword(false);
        setNewPassword('');
      } else {
        setResetMessage(data.message || 'Password reset failed. Try again.');
      }
    } catch (error) {
      setResetMessage('Error connecting to server. Try again later.');
    }
  };

  return (
    <LoginPageContainer>
      <LoginFormWrapper>
        <ClassicToggle>
          
          <ToggleText>9XBET24</ToggleText>
        
        </ClassicToggle>
        
        <LoginFormContainer>
          <Logo>
            <LogoImage src={logoImage} alt="BetGuru Logo" />
          </Logo>

          {!showForgotPassword ? (
            <>
              {error && <ErrorMessage>{error}</ErrorMessage>}
              <form onSubmit={handleSubmit}>
                <FormGroup>
                  <InputLabel>Code</InputLabel>
                  <InputGroup>
                    <IconWrapper>
                      C
                    </IconWrapper>
                    <Input
                      type="text"
                      placeholder="Code"
                      value={userNo}
                      onChange={(e) => {
                        // Remove 'C' prefix if user types it, store only the number part
                        const value = e.target.value.replace(/^C/i, '');
                        setUserNo(value);
                      }}
                      required
                    />
                  </InputGroup>
                </FormGroup>

                <FormGroup>
                  <InputLabel>Password</InputLabel>
                  <InputGroup>
                    <IconWrapper>
                      <FaLock />
                    </IconWrapper>
                    <Input
                      type={showPassword ? "text" : "password"}
                      placeholder="Password"
                      value={password}
                      onChange={(e) => {
                        setPassword(e.target.value);
                      }}
                      required
                    />
                    <PasswordToggle onClick={() => setShowPassword(!showPassword)}>
                      {showPassword ? <FaEyeSlash /> : <FaEye />}
                    </PasswordToggle>
                  </InputGroup>
                </FormGroup>

                <RememberRow>
                  <RememberCheckbox type="checkbox" id="rememberMe" />
                  <RememberLabel htmlFor="rememberMe">Remember me</RememberLabel>
                </RememberRow>

                <LoginButton type="submit">
                  Log in
                </LoginButton>
                
                <DemoButton type="button">
                  Demo
                </DemoButton>
              </form>
            </>
          ) : (
            <>
              {resetMessage && <SuccessMessage>{resetMessage}</SuccessMessage>}
              <form onSubmit={handleForgotPassword}>
                <FormGroup>
                  <InputLabel>Email</InputLabel>
                  <InputGroup>
                    <IconWrapper>
                      <FaUser />
                    </IconWrapper>
                    <Input
                      type="email"
                      placeholder="Your Email"
                      value={email}
                      onChange={(e) => {
                        setEmail(e.target.value);
                        validateResetForm();
                      }}
                      required
                    />
                  </InputGroup>
                </FormGroup>

                <FormGroup>
                  <InputLabel>New Password</InputLabel>
                  <InputGroup>
                    <IconWrapper>
                      <FaLock />
                    </IconWrapper>
                    <Input
                      type={showNewPassword ? "text" : "password"}
                      placeholder="New Password"
                      value={newPassword}
                      onChange={(e) => {
                        setNewPassword(e.target.value);
                        validateResetForm();
                      }}
                      required
                    />
                    <PasswordToggle onClick={() => setShowNewPassword(!showNewPassword)}>
                      {showNewPassword ? <FaEyeSlash /> : <FaEye />}
                    </PasswordToggle>
                  </InputGroup>
                </FormGroup>

                <LoginButton type="submit" disabled={!isResetFormValid}>Reset Password</LoginButton>
                <BackToLoginLink onClick={() => setShowForgotPassword(false)}>
                  Back to Login
                </BackToLoginLink>
              </form>
            </>
          )}
        </LoginFormContainer>

        <FooterText>© 2023 9xBet24</FooterText>
      </LoginFormWrapper>
    </LoginPageContainer>
  );
};


// Styled Components
const LoginPageContainer = styled.div`
  display: flex;
  min-height: 100vh;
  background: #ffffff;
  justify-content: center;
  align-items: center;
  padding: 2rem .5rem;
  position: relative;
`;

const LoginFormWrapper = styled.div`
  width: 100%;
  max-width: 420px;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
`;

const ClassicToggle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: rgba(0, 0, 0, 0.05);
  border-radius: 25px;
  padding: 6px 12px;
  margin-bottom: 1rem;
  position: absolute;
  top: 1px;
  z-index: 10;
`;

const ToggleButton = styled.button`
  background: rgba(0, 0, 0, 0.1);
  border: none;
  border-radius: 50%;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #000000;
  cursor: pointer;
  font-size: 12px;
  
  &:hover {
    background: rgba(0, 0, 0, 0.2);
  }
`;

const ToggleText = styled.span`
  color: #000000;
  font-weight: 600;
  font-size: 12px;
  letter-spacing: 1px;
  text-transform: uppercase;
`;

const LoginFormContainer = styled.div`
  width: 100%;
  max-width: 420px;
  padding: 2.5rem 2rem;
  text-align: center;
  background: #f8f9fa;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 20px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
`;

const Logo = styled.div`
  margin-bottom: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const LogoImage = styled.img`
  width: 120px;
  height: 120px;
  object-fit: contain;
  border-radius: 50%;
`;

const ErrorMessage = styled.p`
  color: #dc2626;
  text-align: center;
  margin-bottom: 1rem;
  font-size: 0.9rem;
  background: rgba(220, 38, 38, 0.1);
  padding: 8px;
  border-radius: 8px;
`;

const FormGroup = styled.div`
  margin-bottom: 1.25rem;
  text-align: left;
`;

const InputLabel = styled.label`
  display: block;
  color: #000000;
  font-size: 0.85rem;
  margin-bottom: 0.5rem;
  font-weight: 500;
`;

const InputGroup = styled.div`
  display: flex;
  align-items: center;
  border: 1px solid rgba(0, 0, 0, 0.2);
  background: #ffffff;
  border-radius: 12px;
  position: relative;
  min-height: 50px;
  overflow: hidden;
`;

const IconWrapper = styled.div`
  width: 50px;
  height: 100%;
 
  color: #000000;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 16px;
  border-right: 1px solid rgba(0, 0, 0, 0.1);
  flex-shrink: 0;
`;

const Input = styled.input`
  flex: 1;
  padding: 14px 16px;
  border: none;
  background: transparent;
  outline: none;
  font-size: 14px;
  color: #000000;

  &::placeholder {
    color: rgba(0, 0, 0, 0.5);
  }
`;

const BackToLoginLink = styled.p`
  text-align: center;
  cursor: pointer;
  color: #000000;
  margin-top: 1rem;
  font-size: 12px;
  
  &:hover {
    color: #333333;
  }
`;

const SuccessMessage = styled.p`
  color: #16a34a;
  text-align: center;
  margin-bottom: 1rem;
  background: rgba(22, 163, 74, 0.1);
  padding: 8px;
  border-radius: 8px;
`;

const PasswordToggle = styled.div`
  position: absolute;
  right: 15px;
  color: #000000;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;

  &:hover {
    color: #333333;
  }
`;

const RememberRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  margin-top: 0.5rem;
  margin-bottom: 1rem;
`;

const RememberCheckbox = styled.input`
  width: 18px;
  height: 18px;
  cursor: pointer;
  accent-color: #000000;
`;

const RememberLabel = styled.label`
  font-size: 14px;
  color: #000000;
  cursor: pointer;
  user-select: none;
`;

const LoginButton = styled.button`
  width: 100%;
  padding: 14px;
  background: #8B7355;
  color: white;
  border: none;
  cursor: pointer;
  font-size: 15px;
  margin-bottom: 1rem;
  font-weight: 600;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(139, 115, 85, 0.4);
  transition: all 0.3s ease;

  &:hover:not(:disabled) {
    background: #7a6348;
    box-shadow: 0 6px 16px rgba(139, 115, 85, 0.5);
    transform: translateY(-2px);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

const DemoButton = styled.button`
  width: 100%;
  padding: 14px;
  background: #3B82F6;
  color: white;
  border: none;
  cursor: pointer;
  font-size: 15px;
  font-weight: 600;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.4);
  transition: all 0.3s ease;

  &:hover {
    background: #2563EB;
    box-shadow: 0 6px 16px rgba(59, 130, 246, 0.5);
    transform: translateY(-2px);
  }
`;

const FooterText = styled.p`
  margin-top: 2rem;
  font-size: 12px;
  color: #000000;
  text-align: center;
`;

export default LoginPage;



